/* eslint-disable no-param-reassign */
import { removeFavoriteArticle, fetchFavoriteArticleIds } from '../memberApi';
import { initFavoriteButton } from './favoriteButton';
import { initFavoriteButtonSticky } from './favoriteButtonSticky';
import Cookie from '../../../shared/menuLogic/cookie';

export { initFavoriteButton };
export { initFavoriteButtonSticky }

const pageSize = 4;
let maxPages;

const createArticleBlurb = function (articleData, imageServer) {
  const parsedUsedImages = JSON.parse(articleData.used_image_ids_json || 'false');
  let img;
  let imageId;
  if (parsedUsedImages) {
    imageId = articleData.image || parsedUsedImages[0];
    img = `<img class="img-cover" src="${imageServer}?imageId=${imageId}&width=800" alt="ELLE"></img>`;
  } else {
    img = `<img class="img-cover" src="/view-resources/public/elle/images/not-a-member-modal-teaser.jpg" alt="ELLE"></img>`;
  }
  const newElement = document.createElement('li');
  newElement.classList.add('article-blurb');
  newElement.id = 'favorite-article-id-' + articleData.id;
  const articleSubtitle = articleData.subtitle ? `<p>${articleData.subtitle}</p>` : '';
  newElement.innerHTML = `<div class="img-wrapper">
                            <a href="${articleData.published_url}">
                              ${img}
                            </a>
                          </div>
                          <div class="flex-justify-between">
                            <span class="article-tag"> ${articleData.section_tag.toUpperCase()} </span>
                            <img class="delete-icon hover-pointer" src="/view-resources/public/elle/images/icon-del.svg" data-article-id="${
                              articleData.id
                            }" alt="Dustbin icon" />
                          </div>
                          <a href="${articleData.published_url}">
                            <h4>${articleData.title}</h4>
                            ${articleSubtitle}
                          </a>`;

  return newElement;
};

const fetchArticleData = async function (ids) {
  if (ids.length === 0) {
    return [];
  }
  const sep = '%20OR%20';
  const labradorApiUrl = process.env.API_BASE_URL;
  const apiUrl = `${labradorApiUrl}article/?query=id:(${ids.join(sep)})`;
  const response = await fetch(apiUrl, { 'Cache-Control': 'no-cache' });
  const data = await response.json();
  return data.result;
};

const handleMaxPagesReached = function (loadMoreButton, loadMoreFunc) {
  loadMoreButton.removeEventListener('click', loadMoreFunc);
  loadMoreButton.classList.remove('hover-pointer');
  loadMoreButton.style.display = 'none';
};

const registerDeleteButtons = function (articlesContainer) {
  const removeButtons = articlesContainer.querySelectorAll('.delete-icon');
  removeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const articleId = button.dataset.articleId;
      removeFavoriteArticle(articleId, Cookie.get('login_token'));
      if (window.cts) {
        cts.send.event('action', 'click', 'remove-favorite-article|remove|'+articleId);
      }
      articlesContainer.removeChild(document.getElementById('favorite-article-id-' + articleId));
      const articles = document.querySelector('.favorite-articles-list');
      if (articles.children.length === 0) {
        const emptyStateElement = document.getElementById('empty-state');
        emptyStateElement.classList.remove('hidden');
      }
    });
  });
};
const loadMore = async function (articlesContainer, articleIds) {
  const currentPage = Number(sessionStorage.getItem('currentPage') || 1);
  const nextPage = currentPage + 1;
  sessionStorage.setItem('currentPage', nextPage);
  const paginatedArticleIds = articleIds.slice(currentPage * pageSize, nextPage * pageSize);
  const labradorArticles = await fetchArticleData(paginatedArticleIds);
  labradorArticles.forEach((articleData) => {
    articlesContainer.appendChild(createArticleBlurb(articleData, articlesContainer.dataset.imageServer));
  });
  registerDeleteButtons(articlesContainer);
  if (maxPages === nextPage) {
    handleMaxPagesReached(document.getElementById('favorite-articles-show-more'), () => {
      loadMore(articlesContainer, articleIds);
    });
  }
};

export const initiateFavoriteArticles = async function () {
  const articlesContainer = document.getElementById('favorite-articles');
  const loadMoreButton = document.getElementById('favorite-articles-show-more');
  const emptyStateElement = document.getElementById('empty-state');
  if (articlesContainer) {
    try {
      const jwt = Cookie.get('login_token');

      const savedArticlesResponse = await fetchFavoriteArticleIds(jwt);

      const articleIds = savedArticlesResponse.data.map((item) => {
        return item.articleId;
      });
      const totalItems = articleIds.length;
      const currentPage = sessionStorage.getItem('pageFetched') || 1;
      sessionStorage.setItem('currentPage', currentPage);
      maxPages = Math.ceil(totalItems / pageSize);

      const paginatedArticleIds = articleIds.slice(0, currentPage * pageSize);
      const labradorArticles = await fetchArticleData(paginatedArticleIds);

      if (labradorArticles && labradorArticles.length > 0) {
        labradorArticles.forEach((articleData) => {
          if (!articlesContainer.classList.contains('loaded')) {
            articlesContainer.classList.add('loaded');
            articlesContainer.innerHTML = '';
          }
          articlesContainer.appendChild(createArticleBlurb(articleData, articlesContainer.dataset.imageServer));
        });
        registerDeleteButtons(articlesContainer);
        // Register delete article listeners

        if (maxPages === currentPage) {
          handleMaxPagesReached(loadMoreButton, () => {
            loadMore(articlesContainer, articleIds);
          });
        } else {
          loadMoreButton.addEventListener('click', () => {
            loadMore(articlesContainer, articleIds);
          });
        }
      } else {
        emptyStateElement.classList.remove('hidden');
        articlesContainer.classList.add('loaded');
        articlesContainer.innerHTML = '';
        handleMaxPagesReached(loadMoreButton, () => {
          loadMore(articlesContainer, articleIds);
        });
      }
    } catch (error) {
      console.error('favorite article error', error);
      articlesContainer.classList.add('loaded');
      articlesContainer.innerHTML = '<p>Hämtningen misslyckades försök igen senare</p>';
    }
  }
};
